document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  document.querySelectorAll('.mobile-toggle').forEach((button) => {
    const header = button.closest('.header');
    if (!header) return;

    const setMenuOpen = (isOpen) => {
      header.classList.toggle('is-open', isOpen);
      button.setAttribute('aria-expanded', String(isOpen));
      button.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    };

    button.addEventListener('click', () => {
      setMenuOpen(!header.classList.contains('is-open'));
    });

    header.querySelectorAll('.nav a, .header-actions a').forEach((link) => {
      link.addEventListener('click', () => setMenuOpen(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setMenuOpen(false);
    });

    window.addEventListener('resize', () => {
      if (window.matchMedia('(min-width: 1121px)').matches) setMenuOpen(false);
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.tshirt-order').forEach(initTshirtOrderBuilder);
});

function initTshirtOrderBuilder(root) {
  const form = root.querySelector('form');
  const sizeInputs = Array.from(root.querySelectorAll('[data-size-input]'));
  const front = root.querySelector('[data-front-colors]');
  const back = root.querySelector('[data-back-colors]');
  const colorInputs = Array.from(root.querySelectorAll('[data-shirt-color]'));
  const tiers = Array.from(root.querySelectorAll('[data-pricing-tier]'));
  const minimum = Number(root.dataset.minimum || 0);

  const money = (value) => `$${Number(value || 0).toFixed(2)}`;
  const number = (value) => Number.parseFloat(String(value || '0').replace(/[^0-9.]/g, '')) || 0;
  const setSummary = (key, value) => {
    const target = root.querySelector(`[data-summary="${key}"]`);
    if (target) target.textContent = value;
  };
  const setHidden = (key, value) => {
    const target = root.querySelector(`[data-tshirt-hidden="${key}"]`);
    if (target) target.value = value;
  };

  const calculate = () => {
    let total = 0;
    let upchargeTotal = 0;
    const breakdown = [];

    sizeInputs.forEach((input) => {
      const qty = Math.max(0, Number.parseInt(input.value || '0', 10) || 0);
      input.value = qty || 0;
      total += qty;
      upchargeTotal += qty * number(input.dataset.upcharge);
      if (qty > 0) breakdown.push(`${input.dataset.sizeLabel}: ${qty}`);
    });

    const frontColors = Number.parseInt(front.value, 10) || 1;
    const backColors = Number.parseInt(back.value, 10) || 0;
    const code = `${frontColors}/${backColors}`;
    const priceAttr = `data-price-${frontColors}-${backColors}`;
    let activeTier = null;

    tiers.forEach((tier) => {
      const min = Number.parseInt(tier.dataset.min || '0', 10) || 0;
      const max = Number.parseInt(tier.dataset.max || '0', 10) || 0;
      const isActive = total >= min && (max === 0 || total <= max);
      tier.classList.toggle('is-active', isActive);
      tier.querySelectorAll('td').forEach((cell) => cell.classList.remove('is-active'));
      if (isActive) activeTier = tier;
    });

    if (!activeTier && total > 0 && tiers.length) {
      activeTier = tiers.reduce((best, tier) => {
        const min = Number.parseInt(tier.dataset.min || '0', 10) || 0;
        return total >= min ? tier : best;
      }, tiers[0]);
      activeTier.classList.add('is-active');
    }

    const baseUnitPrice = activeTier ? number(activeTier.getAttribute(priceAttr)) : 0;
    if (activeTier) {
      const cellIndex = (frontColors - 1) * 5 + backColors;
      const priceCell = activeTier.querySelectorAll('td')[cellIndex];
      if (priceCell) priceCell.classList.add('is-active');
    }

    const estimate = total * baseUnitPrice + upchargeTotal;
    const shirtColor = (colorInputs.find((input) => input.checked) || {}).value || '-';
    const minimumNote = total > 0 && total < minimum ? `Minimum order is ${minimum} shirts. Add ${minimum - total} more for standard pricing.` : '';

    setSummary('shirt_color', shirtColor);
    setSummary('total_shirts', String(total));
    setSummary('pricing_code', code);
    setSummary('base_unit_price', money(baseUnitPrice));
    setSummary('size_upcharge_total', money(upchargeTotal));
    setSummary('estimated_total', money(estimate));
    setSummary('minimum_note', minimumNote);

    setHidden('pricing_code', code);
    setHidden('total_shirts', String(total));
    setHidden('size_breakdown', breakdown.join(', ') || 'No sizes entered');
    setHidden('base_unit_price', money(baseUnitPrice));
    setHidden('size_upcharge_total', money(upchargeTotal));
    setHidden('estimated_total', money(estimate));

    return { total, minimum };
  };

  root.addEventListener('input', calculate);
  root.addEventListener('change', calculate);
  if (form) {
    form.addEventListener('submit', (event) => {
      const result = calculate();
      if (result.total < result.minimum) {
        event.preventDefault();
        alert(`Please enter at least ${result.minimum} shirts before submitting this order.`);
      }
    });
  }
  calculate();
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sticker-order').forEach(initStickerOrderBuilder);
});

function initStickerOrderBuilder(root) {
  const form = root.querySelector('form');
  const widthInput = root.querySelector('[data-sticker-width]');
  const heightInput = root.querySelector('[data-sticker-height]');
  const stickerTypeInput = root.querySelector('[data-sticker-type]');
  const finishInput = root.querySelector('[data-sticker-finish]');
  const useCaseInput = root.querySelector('[data-sticker-use-case]');
  const presetInputs = Array.from(root.querySelectorAll('[data-sticker-preset]'));
  const qtyOptions = Array.from(root.querySelectorAll('[data-sticker-qty-option]'));
  const customQtyRadio = root.querySelector('[data-sticker-qty-custom-radio]');
  const customQtyInput = root.querySelector('[data-sticker-custom-qty]');
  const tiers = Array.from(root.querySelectorAll('[data-sticker-tier]'));
  const minimum = Number.parseInt(root.dataset.minimum || '50', 10) || 50;
  const maximum = Number.parseInt(root.dataset.maximum || '10000', 10) || 10000;
  const minWidth = Number.parseFloat(root.dataset.minWidth || '0.5') || 0.5;
  const maxWidth = Number.parseFloat(root.dataset.maxWidth || '18') || 18;
  const minHeight = Number.parseFloat(root.dataset.minHeight || '0.5') || 0.5;
  const maxHeight = Number.parseFloat(root.dataset.maxHeight || '18') || 18;
  const billableMinimum = Number.parseFloat(root.dataset.billableMin || '5') || 5;

  const money = (value) => `$${Number(value || 0).toFixed(2)}`;
  const wholeDollars = (value) => `$${Math.max(0, Math.floor(Number(value || 0))).toLocaleString()}`;
  const decimal = (value, places = 2) => Number(value || 0).toFixed(places);
  const parseMoney = (value) => Number.parseFloat(String(value || '0').replace(/[^0-9.]/g, '')) || 0;
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const skuQuantities = [50, 100, 200, 300, 500, 1000, 2000, 3000, 5000, 10000];
  const padSkuNumber = (value, length) => String(Math.max(0, Number.parseInt(value, 10) || 0)).padStart(length, '0');
  const getSkuPrefix = (type) => {
    if (/bumper/i.test(type)) return 'BS';
    if (/sheet/i.test(type)) return 'SS';
    return 'CS';
  };
  const getMatchingSku = (prefix, squareInches, quantity) => {
    const skuSquareInches = Math.ceil(squareInches);
    const hasExactQuantity = skuQuantities.includes(quantity);
    if (skuSquareInches < 5 || skuSquareInches > 100 || !hasExactQuantity) return '';
    return `${prefix}-SQ${padSkuNumber(skuSquareInches, 3)}-Q${padSkuNumber(quantity, 5)}`;
  };
  const setSummary = (key, value) => {
    const target = root.querySelector(`[data-sticker-summary="${key}"]`);
    if (target) target.textContent = value;
  };
  const setHidden = (key, value) => {
    const target = root.querySelector(`[data-sticker-hidden="${key}"]`);
    if (target) target.value = value;
  };

  const selectCustomSize = () => {
    const custom = presetInputs.find((input) => input.value === 'custom');
    if (custom) custom.checked = true;
  };

  const getQuantity = () => {
    if (customQtyRadio && customQtyRadio.checked) {
      return Number.parseInt(customQtyInput.value || '0', 10) || 0;
    }
    const selected = qtyOptions.find((input) => input.checked) || qtyOptions[0];
    return Number.parseInt(selected ? selected.value : minimum, 10) || minimum;
  };

  const findTier = (quantity) => {
    let active = null;
    tiers.forEach((tier) => {
      const min = Number.parseInt(tier.dataset.min || '0', 10) || 0;
      const max = Number.parseInt(tier.dataset.max || '0', 10) || 0;
      const isActive = quantity >= min && (max === 0 || quantity <= max);
      tier.classList.toggle('is-active', isActive);
      if (isActive) active = tier;
    });
    if (!active && tiers.length) {
      active = tiers.reduce((best, tier) => {
        const min = Number.parseInt(tier.dataset.min || '0', 10) || 0;
        return quantity >= min ? tier : best;
      }, tiers[0]);
      active.classList.add('is-active');
    }
    return active;
  };

  const calculate = () => {
    const width = clamp(Number.parseFloat(widthInput.value || '0') || minWidth, minWidth, maxWidth);
    const height = clamp(Number.parseFloat(heightInput.value || '0') || minHeight, minHeight, maxHeight);
    widthInput.value = decimal(width);
    heightInput.value = decimal(height);

    const quantity = getQuantity();
    const tier = findTier(quantity);
    const squareInches = width * height;
    const roundedSquareInches = Math.ceil(squareInches * 100) / 100;
    const billableSquareInches = Math.max(roundedSquareInches, billableMinimum);
    const rate = tier ? parseMoney(tier.dataset.rate) : 0;
    const minimumTotal = tier ? parseMoney(tier.dataset.minTotal) : 0;
    const calculatedTotal = billableSquareInches * quantity * rate;
    const total = quantity > 0 ? Math.floor(Math.max(calculatedTotal, minimumTotal)) : 0;
    const unit = quantity > 0 ? total / quantity : 0;
    const label = tier ? tier.dataset.label : '-';
    const stickerType = stickerTypeInput ? stickerTypeInput.value : 'Custom stickers';
    const finish = finishInput ? finishInput.value : '';
    const useCase = useCaseInput ? useCaseInput.value : '';
    const quantityLabel = quantity ? quantity.toLocaleString() : '0';
    const invoiceTotal = wholeDollars(total);
    const skuPrefix = getSkuPrefix(stickerType);
    const draftOrderSku = getMatchingSku(skuPrefix, billableSquareInches, quantity);
    const skuValue = draftOrderSku || 'Custom review';
    const draftOrderTitle = `${stickerType} - ${decimal(width)} x ${decimal(height)} in - ${quantityLabel} qty`;
    const draftOrderNote = `Custom sticker invoice request: SKU ${skuValue}; ${quantityLabel} ${stickerType}; size ${decimal(width)} x ${decimal(height)} in; ${decimal(billableSquareInches)} billable sq in; ${label} price break; finish: ${finish}; use case: ${useCase}; estimated invoice total: ${invoiceTotal}.`;
    const warnings = [];

    if (quantity > 0 && quantity < minimum) warnings.push(`Minimum sticker order is ${minimum}.`);
    if (quantity > maximum) warnings.push(`For quantities over ${maximum.toLocaleString()}, send this as a custom quote request.`);
    if (quantity >= minimum && quantity <= maximum && !draftOrderSku) warnings.push('No exact imported SKU exists for this size or quantity, so we will review it as a custom invoice.');

    setSummary('size', `${decimal(width)} x ${decimal(height)} in`);
    setSummary('square_inches', decimal(roundedSquareInches));
    setSummary('billable_square_inches', decimal(billableSquareInches));
    setSummary('quantity', quantityLabel);
    setSummary('price_break', label);
    setSummary('sku', skuValue);
    setSummary('rate', `$${decimal(rate, 5)} / billable sq in`);
    setSummary('unit_price', money(unit));
    setSummary('estimated_total', invoiceTotal);
    setSummary('warning', warnings.join(' '));

    setHidden('sticker_size', `${decimal(width)} x ${decimal(height)} in`);
    setHidden('square_inches', decimal(roundedSquareInches));
    setHidden('billable_square_inches', decimal(billableSquareInches));
    setHidden('quantity', quantity ? String(quantity) : '0');
    setHidden('price_break', label);
    setHidden('draft_order_sku', skuValue);
    setHidden('rate_per_square_inch', `$${decimal(rate, 5)}`);
    setHidden('estimated_unit_price', money(unit));
    setHidden('estimated_total', invoiceTotal);
    setHidden('draft_order_line_item_title', draftOrderTitle);
    setHidden('draft_order_line_item_price', invoiceTotal);
    setHidden('draft_order_note', draftOrderNote);

    return { quantity, minimum, maximum };
  };

  presetInputs.forEach((input) => {
    input.addEventListener('change', () => {
      if (!input.checked || input.value === 'custom') return;
      widthInput.value = input.dataset.width || widthInput.value;
      heightInput.value = input.dataset.height || heightInput.value;
      calculate();
    });
  });

  [widthInput, heightInput].forEach((input) => {
    input.addEventListener('input', selectCustomSize);
  });

  if (customQtyInput && customQtyRadio) {
    customQtyInput.addEventListener('input', () => {
      customQtyRadio.checked = true;
    });
  }

  root.addEventListener('input', calculate);
  root.addEventListener('change', calculate);
  if (form) {
    form.addEventListener('submit', (event) => {
      const result = calculate();
      if (result.quantity < result.minimum || result.quantity > result.maximum) {
        event.preventDefault();
        alert(`Please enter a sticker quantity from ${result.minimum} to ${result.maximum.toLocaleString()}.`);
      }
    });
  }
  calculate();
}
